<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="8" stroke="#00B9FF" stroke-width="1.5"/>
    <circle cx="8" cy="8" r="1.5" fill="#00B9FF"/>
    <circle cx="16" cy="8" r="1.5" fill="#00B9FF"/>
    <circle cx="8" cy="16" r="1.5" fill="#00B9FF"/>
    <circle cx="16" cy="16" r="1.5" fill="#00B9FF"/>
    <path d="M8 8L16 16M16 8L8 16" stroke="#00B9FF" stroke-width="1" opacity="0.5"/>
  </svg>
</template>

<script>
export default {
  name: 'IconEcosystem'
}
</script>
